import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'typeface-roboto';

import { ApolloProvider } from '@apollo/react-hooks';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { createReduxHistory } from '@store/config/history';
import { apolloClient } from '@api/client';
import { theme } from '@style/theme';

import './core/i18n/i18n';
import AppRoutes from './routes';
import store from './store/store';

// window.onbeforeunload = () => 'Do you really want to leave Knygos?';

const history = createReduxHistory(store);

const MOUNT_NODE = document.getElementById('app');

const renderRoot = (Component) =>
  render(
    <MuiThemeProvider theme={theme}>
      <ApolloProvider client={apolloClient}>
        <Provider store={store}>
          <Router history={history}>
            <Component store={store} />
          </Router>
        </Provider>
      </ApolloProvider>
    </MuiThemeProvider>,
    MOUNT_NODE,
  );

// if (process.env.NODE_ENV !== 'production') {
//   const {whyDidYouUpdate} = require('why-did-you-update');
//   whyDidYouUpdate(React, { groupByComponent: true, collapseComponentGroups: false });
// }

renderRoot(
  AppRoutes,
);

